import { CAPTCHA_TYPE_GOOGLE, CAPTCHA_TYPE_YANDEX } from '@/constants';

/**
 * Сброс капчи после успешной отправки или ошибки валидации
 * @param {string} captchaType - тип капчи ('google' или 'yandex')
 * @param {string} yandexCaptchaBlockSelector - селектор блока Yandex Captcha
 * @param {string} googleRecaptchaBlockSelector - селектор блока Google reCAPTCHA
 * @param {string} formType - тип формы ('comment', 'feedback', 'review')
 * @returns {void}
 */
export default function resetCaptcha({
  captchaType,
  yandexCaptchaBlockSelector,
  googleRecaptchaBlockSelector,
  formType
} = {}) {
  if (!yandexCaptchaBlockSelector || !googleRecaptchaBlockSelector || !captchaType) {
    return;
  }

  if (captchaType === CAPTCHA_TYPE_YANDEX && window.smartCaptcha) {
    try {
      document.querySelectorAll(yandexCaptchaBlockSelector).forEach((captchaBlock) => {
        // Сбрасываем виджет Yandex Captcha
        if (captchaBlock.dataset.yandexCaptchaWidgetId) {
          window.smartCaptcha.reset(captchaBlock.dataset.yandexCaptchaWidgetId);
        }

        // Очищаем токены в скрытых полях
        const tokenSelectors = [
          '[name="yandex-smart-token"]',
          `[name="${formType}[yandex-smart-token]"]`
        ];

        tokenSelectors.forEach(selector => {
          const input = captchaBlock.querySelector(selector);
          if (input) {
            input.value = '';
          }
        });
      });
    } catch (errorMessage) {
      console.error(
        `resetCaptcha ${formType}. Произошла ошибка при попытке сбросить виджет Yandex Captcha: `, errorMessage
      );
    }

    return;
  }

  if (captchaType === CAPTCHA_TYPE_GOOGLE && window.grecaptcha) {
    try {
      document.querySelectorAll(googleRecaptchaBlockSelector).forEach((captchaBlock) => {
        // Сбрасываем виджет Google reCAPTCHA
        window.grecaptcha.reset(captchaBlock);
      });
    } catch (errorMessage) {
      console.error(
        `[resetCaptcha ${formType}]. Произошла ошибка при попытке сбросить виджет Google reCAPTCHA: `, errorMessage
      );
    }
  }
}
